<template>
	<v-container v-if="$vuetify.breakpoint.mdAndUp" fluid>
		<subHeader />

		<v-row class="d-flex justify-center align-center">
			<v-container class="container-pnr">
				<v-row>
					<v-col>
						<h2 class="duo" style="font-family: AirNZ Sans Regular !important; font-size: 28px !important; color: black !important">
							<span style="font-family: AirNZ Sans Semibold !important">Welcome to duoshare</span>
						</h2>
					</v-col>
				</v-row>
				<v-row style="margin-top: -0.5vw;">
					<v-col>
						<v-img :src="$bucket + '/image/dashboard-tiles/DuoShareHeroImage.jpeg'"/>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="11">
						Created to bring our trade partners closer to the Air New Zealand whānau and our whānau closer to you, <span style="font-family: AirNZ Sans Semibold !important">duo</span>share is where stories take flight. Whether it’s a standout event, a memorable trip, or a travel tip that deserves the spotlight, this is the place to post, react, and relive the moments that make our partnership special.
						<br/><br/>
						From safety videos and festive reels to behind-the-scenes snapshots and shared wins, <span style="font-family: AirNZ Sans Semibold !important">duo</span>share is designed to spark kōrero, build connections, and create lasting memories. It’s social, it’s simple, and it’s all about us, together.
						<br/><br/>
						<span style="font-family: AirNZ Sans Semibold !important">duo</span>share - where our journeys meet.
						<br/><br/>
					</v-col>
				</v-row>
				<v-row align="center">
					<v-col cols="8">
						<h3>
							<span style="font-family: AirNZ Sans Semibold !important">duo</span>share is your space to connect, celebrate, and share the journey.
						</h3>
					</v-col>
					<v-col cols="2" align="right" v-if="isCanPost">
						<v-btn outlined elevation="0" class="btn-new-post" @click="addDialog = true">New Post</v-btn>
					</v-col>
				</v-row>

				<v-row style="margin-top: -0.5vw;">
					<v-col cols="10">
						<v-row no-gutters v-for="(post, index) in visiblePosts" :key="index" class="custom-v-card mt-2 mr-2 mb-6 elevation-0" align="center" justify="center" style="border-radius: 6px">
							<v-col class="d-flex flex-column">
								<v-row no-gutters class="d-flex flex-row" justify="space-between" style="padding: 24px 24px 0px 24px">
									<v-col class="px-1" style="font-family: AirNZ Sans Semibold; font-size: 18px; line-height: 21px; color: black !important">
										<p style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 13px;">{{ post.creatorName }} - {{ post.createdDate }}</p>
									</v-col>
									<v-col align="right">
										<v-icon
											v-if="post.creatorEmail == $store.state.principal.email"
											size="18" class="ml-2" @click="showPostEdit(post)">
											mdi-pencil
										</v-icon>
										<v-icon
											v-if="post.creatorEmail == $store.state.principal.email"
											size="18" class="ml-2 icon-tm-delete" @click="showDeletePost(post)">
										</v-icon>
									</v-col>
								</v-row>
								<v-row no-gutters class="d-flex flex-row" justify="space-between" style="padding: 0px 24px 15px 24px">
									<v-col class="px-1" style="font-family: AirNZ Sans Semibold; font-size: 26px; line-height: 21px; color: black !important">
										{{ post.title }}
									</v-col>
								</v-row>
								<v-row no-gutters class="d-flex flex-row" justify="space-between" style="padding: 3px 24px 0px 24px">
									<v-col class="px-1" style="font-family: AirNZ Sans Regular; font-size: 18px; line-height: 21px; color: black !important">
										<p style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 16px;">
											<span v-html="post.content"></span>
										</p>
									</v-col>
								</v-row>
								<v-row no-gutters class="d-flex flex-row" justify="space-between" style="padding: 0px 24px 0px; margin-bottom: -15px">
									<v-col class="px-1" style="font-family: AirNZ Sans Regular; font-size: 18px; line-height: 21px;">
										<v-textarea v-model="newComment[index]" placeholder="Leave a comment" outlined :rows="2"></v-textarea>
									</v-col>
								</v-row>
								<v-row
									no-gutters
									class="d-flex flex-row"
									justify="space-between"
									align="center"
									style="padding: 0px 20px 10px 24px"
									>
									<v-col
										class="px-1"
										style="font-family: AirNZ Sans Regular; font-size: 18px; line-height: 21px; color: black !important"
									>
										<p style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 16px;">
										{{ post.numberOfComment }} <span v-if="post.numberOfComment == 1">comment</span><span v-else>comments</span>
										</p>
									</v-col>
									<v-col class="d-none d-sm-block">
										<v-row no-gutters class="px-0" justify="end" align="center">
										<!-- <v-btn :disabled="!($store.state.principal.role == 'super_user' || $store.state.principal.canPost)" outlined elevation="0" id="submitPnr" class="btn-enter" @click="addComment(post.id)"> -->
										<v-btn outlined elevation="0" id="submitPnr" class="btn-comment" @click="addComment(post.id, newComment[index], index)" :disabled="!newComment[index] || newComment[index].length < 3">
											Comment
										</v-btn>
										</v-row>
									</v-col>
								</v-row>

								<hr v-if="post.numberOfComment > 0" style="margin: 0 auto; height: 1px; border: none; background-color: #ccc; width: 95%;">

								<!-- Comments start -->
								<v-col v-for="(comment, index) in post.comments" :key="index">
									<v-row  no-gutters class="d-flex flex-row" justify="space-between" style="padding: 0px 24px 0px 24px">
										<v-col class="px-1" style="font-family: AirNZ Sans Semibold; font-size: 18px; line-height: 21px; color: black !important">
											<p style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 16px;"><strong>{{ comment.creatorName }}</strong></p>
										</v-col>
										<v-col class="d-none d-sm-block" align="right">
											<p style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 16px;">{{ comment.createdDate }}</p>
										</v-col>
									</v-row>
									<v-row no-gutters class="d-flex flex-row" justify="space-between" style="padding: 0px 24px 0px 24px">
										<v-col class="px-1" style="font-family: AirNZ Sans Semibold; font-size: 18px; line-height: 21px; color: black !important">
											<p style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 16px;">
												{{ comment.text }}
											</p>
										</v-col>
										<v-col align="right">
											<v-icon
												v-if="comment.creatorEmail == $store.state.principal.email"
												size="18" class="" @click="showCommentEdit(comment)">mdi-pencil
											</v-icon>
											<v-icon
												v-if="comment.creatorEmail == $store.state.principal.email"
												size="18" class="ml-2 icon-tm-delete" @click="showDeleteComment(comment)">
											</v-icon>
										</v-col>
									</v-row>
								</v-col>

								<!-- Comments end -->

								<hr v-if="post.numberOfComment > 0" style="margin: 0 auto; height: 1px; border: none; background-color: #ccc; width: 95%;">
								<v-row v-if="post.numberOfComment > 0" no-gutters class="d-flex flex-row" justify="space-between" style="padding: 10px 24px 0px 24px">
									<v-col class="px-1" style="font-family: AirNZ Sans Semibold; font-size: 18px; line-height: 21px; color: black !important">
										<p @click="viewAllComments(post)" class="hover-purple" style="cursor: pointer; font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 16px; color: purple">
											View all comments
										</p>
									</v-col>
								</v-row>

							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row justify="center" class="mt-2 mb-8">
					<v-col cols="3">
						<v-btn v-if="hasMore" @click="loadMore" color="primary">
							Load More
						</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</v-row>

		<v-dialog v-model="addDialog" persistent max-width="900px">
			<v-card>
				<v-card-title>
				<span class="headline">Add Post</span>
				</v-card-title>
				<v-card-text>
					<v-form ref="form" style="padding: 15px 40px; margin-bottom: -25px;" autocomplete="off">
						<v-text-field
						v-model="entity.title"
						label="Title"
						outlined
						></v-text-field>
						<v-text-editor v-if="addDialog" label="Content" v-model="entity.content" :api-key="$tinyMceKey" :init="selectedInitEditor()"></v-text-editor>
						<p style="text-align: right; font-size: 12px; font-style: italic;">
						*) To resize an image, use the little blue squares on the corners of the image.
						</p>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="closeAddDialog" class="btn-cancel mb-4">Cancel</v-btn>
					<v-btn @click="addPost" class="btn-save mb-4 mr-12">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogDeletePost" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Delete Post</span>
				</v-card-title>
				<v-card-text style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 16px;">Are you sure you want to delete '{{ entity.title }}' ?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogDeletePost = false; entity = {}">Cancel</v-btn>
					<!-- <v-btn @click="deletePost" color="accent" :disabled="!($store.state.principal.role == 'super_user' || $store.state.principal.canPost)" >Delete</v-btn> -->
					<v-btn @click="deletePost" color="accent">Delete</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogDeleteComment" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Delete Comment</span>
				</v-card-title>
				<v-card-text style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 16px;">Are you sure you want to delete '{{ comment.text }}' ?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogDeleteComment = false; comment = {}">Cancel</v-btn>
					<!-- <v-btn @click="deleteComment" color="accent" :disabled="!($store.state.principal.role == 'super_user' || $store.state.principal.canPost)" >Delete</v-btn> -->
					<v-btn @click="deleteComment" color="accent" >Delete</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogPostEdit" persistent max-width="900px">
			<v-card>
				<v-card-title>
				<span class="headline">Edit Post</span>
				</v-card-title>
				<v-card-text>
				<v-form ref="form" style="padding: 15px 40px; margin-bottom: -25px;" autocomplete="off">
					<v-text-field
					v-model="entity.title"
					label="Title*"
					outlined
					></v-text-field>
					<v-text-editor v-if="dialogPostEdit" label="Content" v-model="entity.content" :api-key="$tinyMceKey" :init="selectedInitEditor()"></v-text-editor>
					<p style="text-align: right; font-size: 12px; font-style: italic;">
					*) To resize an image, use the little blue squares on the corners of the image.
					</p>
				</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogPostEdit = false;" class="btn-cancel mb-4">Cancel</v-btn>
					<v-btn @click="editPost(entity)" class="btn-save mb-4 mr-12">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogCommentEdit" persistent max-width="900px">
			<v-card>
				<v-card-title>
				<span class="headline">Edit Comment</span>
				</v-card-title>
				<v-card-text>
				<v-form ref="form" style="padding: 15px 40px; margin-bottom: -60px;" autocomplete="off">
          <v-textarea v-model="comment.text" placeholder="Leave a comment" outlined :rows="2"></v-textarea>
				</v-form>
				</v-card-text>
				<v-card-actions>
				<v-spacer></v-spacer>
					<v-btn @click="dialogCommentEdit = false; comment = {}" class="btn-cancel mb-4">Cancel</v-btn>
					<!-- <v-btn @click="editComment(comment)" color="primary" :disabled="!($store.state.principal.role == 'super_user' || $store.state.principal.canPost)" >Save</v-btn> -->
					<v-btn @click="editComment(comment)" class="btn-save mb-4 mr-12">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</v-container>

</template>

<style scoped>
.hover-purple:hover {
  color: black;
}
.v-btn--text {
	text-transform: none !important;
	text-decoration: underline;
	letter-spacing: 0px;
}
.btn-new-post {
	width: 162px !important;
	height: 46px !important;
	border: 1px solid #440099;
	background-color: #440099 !important;
	border-radius: 4px;
	opacity: 1;
	color: white !important;
	text-transform: none !important;
	font-size: 17px !important;
	letter-spacing: 0px;
}
.btn-comment {
	width: 200px !important;
	height: 46px !important;
	border: 1px solid #0c0c0c;
	background-color: #0c0c0c !important;
	border-radius: 4px;
	opacity: 1;
	color: white !important;
	text-transform: none !important;
	font-size: 17px !important;
	letter-spacing: 0px;
}
.btn-comment[disabled] {
  background-color: #ccc !important;
  color: #666 !important;
  border-color: #999 !important;
  cursor: not-allowed;
}
.btn-save {
	width: 162px !important;
	height: 46px !important;
	border: 1px solid #0c0c0c;
	background-color: #0c0c0c !important;
	border-radius: 6px;
	opacity: 1;
	color: white !important;
	text-transform: none !important;
}
.btn-cancel {
	width: 162px !important;
	height: 46px !important;
	border: 1px solid black;
	border-radius: 6px;
	color: black !important;
	opacity: 1;
	text-transform: none !important;
}
.theme--light.v-label {
	color: black !important;
	font-size: 17px !important;
}
.btn-add-pnr {
	width: 40px !important;
	height: 40px !important;
	margin: 0px !important;
	background-color: #440099 !important;
	border-radius: 5px;
	color: white !important;
}
.pnr-input {
	width: 50px;
	height: 45px;
	/* padding: 5px; */
	margin: 0 3px;
	font-size: 20px;
	border-radius: 4px;
	border: 1px solid rgb(0, 0, 0);
	text-align: center;
}
.no-background-hover::before {
	background-color: transparent !important;
}
.error--text {
	font-family: "AirNZ Sans Regular", arial, sans-serif !important;
	color: #ec040f !important;
	font-size: 12px !important;
}
/*
.v-application .reduce-box.mr-1 {
    margin-right: 20px !important;
}
*/
.reduce-box.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
	padding: 0 0px;
	min-height: unset;
}
.reduce-box fieldset {
	width: 50px;
	height: 50px;
}
.reduce-box .v-text-field__slot {
	width: 50px;
	height: 50px;
	margin-bottom: -5px;
}
.theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
	background: #c9c9c9;
}
.custom-v-card {
	box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
	border-radius: 4px;
	background-color: rgba(255, 255, 255, 0.9);
	color: rgba(0, 0, 0, 0.87);
	border-width: thin;
	max-width: 100%;
	outline: none;
	text-decoration: none;
	transition-property: box-shadow, opacity;
	overflow-wrap: break-word;
	position: relative;
	white-space: normal;
	min-height: 166px;
	opacity: 0.9;
}
.xl-add-pnr {
	position: absolute;
	top: 0;
	right: 0;
	margin: 35px 40px 0 0;
}
/* secondary */
button.duo-secondary > span {
	color: #008392;
}
button.duo-secondary:hover > span {
	color: #00626e;
}
button.duo-secondary {
	border: thin solid black !important;
	color: black !important;
}
button.duo-primary {
	border: thin solid #008392 !important;
}
button.duo-secondary .v-btn__content {
	color: black !important;
}
button.duo-secondary:hover .v-btn__content {
	color: #00626e !important;
}
button.duo-secondary:hover {
	border: thin solid #00626e !important;
}
button.duo-secondary::before {
	background-color: transparent !important;
}
.v-expansion-panel-header__icon {
	padding-right: 0px;
}
.theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
	color: #440099 !important;
}
.row-pnr-input {
	padding: 0 15px 0 25px;
}
/* Extra large devices (large desktops, 1200px and up) */
@media (max-width: 1200px) {
	.container-pnr {
		width: 95%;
	}
}
@media (max-width: 600px) {
	.theme--light.v-label {
		color: black !important;
		font-size: 14px !important;
	}
	.row-pnr-input {
		padding: 0 10px 10px 10px;
	}
	.container-pnr {
		padding: 0px 5px;
	}
	.row-pnr-head {
		padding: 20px 10px 0;
	}
}
</style>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-extra-boolean-cast */
import axios from "axios";
import subHeader from "./subHeader.vue";
import Editor from "@tinymce/tinymce-vue";

export default {
	components: {
		subHeader,
		"v-text-editor": Editor,
	},
	computed: {
		visiblePosts() {
			return this.postList.slice(0, this.visibleCount);
		},
		hasMore() {
			return this.visibleCount < this.postList.length;
		}
	},
	data() {
		return {
			addDialog: false,
			entity: { 
				map: {},
				title: "",
				content: "" 
			},
			comment: {},
			postList: [],
			visibleCount: 5,
			initEditor: {
					height: 150,
					width: '100%',
					selector: '',
					menubar: false,
					plugins: ["code", "paste", "table", "lists", "link", "textcolor" ],
					paste_as_text: true,
					fontsize_formats: "8px 9px 10px 11px 12px 13px 14px 15px 16px 17px 18px 20px 21px 22px 23px 24px 25px 26px 27px 28px 29px 30px 31px 32px 33px 34px 35px 36px",
					font_formats: "Arial=arial,helvetica,sans-serif; \
                                    Courier New=courier new,courier,monospace; \
                                    Georgia=georgia,palatino; \
                                    Tahoma=tahoma,arial,helvetica,sans-serif; \
                                    Times New Roman=times new roman,times; \
                                    Verdana=verdana,geneva;",
                    toolbar:
							"code undo redo | fontsizeselect | fontselect | bold italic underline forecolor backcolor | table | \
                                alignleft aligncenter alignright alignjustify | \
                                bullist numlist outdent indent | link | removeformat | pastetext | help"
			},
			dialogDeletePost: false,
			dialogDeleteComment: false,
			dialogPostEdit: false,
			dialogCommentEdit: false,
			isCanPost: false,
			newComment: []
		};
	},
	mounted: function () {
		this.getPosts();
		this.getPostAcess();
	},
	methods: {
		loadMore() {
			this.visibleCount += 5;
		},
		getPostAcess() {
			axios
            .get("/system/globalsetting/get")
            .then((response) => {
				this.isCanPost = response.data.canPost;
            });
		},
		editComment(comment) {
          axios
            .post("/system/comment/edit", { entity: comment })
            .then(() => {
                this.dialogCommentEdit = false;
                this.getPosts();
            });
        },
        showCommentEdit(comment) {
          this.dialogCommentEdit = true;
          this.comment = comment;
        },
		editPost(entity) {
          axios
            .post("/system/post/edit", { entity: entity })
            .then(() => {
                this.dialogPostEdit = false;
                this.getPosts();
				this.entity.title = "";
				this.entity.content = "";
            });
        },
        showPostEdit(post) {
          this.dialogPostEdit = true;
          this.entity = post;
        },
		deleteComment() {
			axios
				.post("/system/comment/delete", { id: this.comment.id })
				.then(() => {
					this.dialogDeleteComment = false;
					this.getPosts();
					this.comment = {}
				})
				.catch(() => {});
			
		},
		showDeleteComment(item) {
			this.comment = item;
			this.dialogDeleteComment = true;
		},
		deletePost() {
			axios
				.post("/system/post/delete", { id: this.entity.id })
				.then(() => {
					this.dialogDeletePost = false;
					this.getPosts();
					this.entity = {}
				})
				.catch(() => {});
			
		},
		showDeletePost(item) {
			this.entity = item;
			this.dialogDeletePost = true;
		},
		viewAllComments(post) {

			this.$router.push({path: "/share/"+post.id});
		},
		addComment(postId, comment, index) {

			this.comment.text = comment;
			this.comment.postId = postId;
			axios
				.post("/system/comment/add", { entity: this.comment })
				.then(() => {
					this.newComment[index] = "";
					this.comment.text = null
					this.comment.postId = null
					this.comment.id = null
					this.getPosts();
				});
		},
		selectedInitEditor() {
			return this.$root.copyWith({ 
				height: 300,
				toolbar: 'undo redo | fontsizeselect fontselect | bold italic underline | forecolor backcolor removeformat | table | alignleft aligncenter alignright alignjustify | bullist numlist | link image media pastetext',
				plugins: 'image media link table lists charmap paste placeholder',
				placeholder: 'Content',
				file_picker_types: 'image',
				file_picker_callback: function (callback, value, meta) {
				if (meta.filetype === 'image') {
					const input = document.createElement('input')
					input.setAttribute('type', 'file')
					input.setAttribute('accept', 'image/jpeg, image/jpg, image/png, image/gif, image/bmp')

					input.onchange = function () {
					const file = this.files[0]
					const reader = new FileReader()

					reader.onload = function () {
						const base64 = reader.result
						callback(base64, { title: file.name })
					}

					reader.readAsDataURL(file)
					}

					input.click()
				}
				},
			}, 
				this.initEditor);
		},
		closeAddDialog() {
			this.entity = {};
			this.addDialog = false;
		},
		addPost() {
			axios
			.post("/system/post/add", { entity: this.entity })
			.then(() => {
				this.addDialog = false;
				this.getPosts();
				this.entity.title = "";
				this.entity.content = "";
			});

		},
		getPosts() {
			axios
			.get("/system/post/list")
			.then((response) => {
				this.postList = response.data;
				this.getLastComment()
			})
			.catch(() => { });
		},
		getLastComment() {

			this.postList.forEach((post, index) => {

				axios
				.post("/system/comment/last", { postId: post.id })
				.then((response) => {
					this.$set(this.postList[index], 'comments', response.data == null ? {} : response.data.lastComment);
					this.$set(this.postList[index], 'numberOfComment', response.data == null ? 0 : response.data.commentSize);
				});

			})
		},
	},
};
</script>
